module.exports = __webpack_public_path__ + "img/auto-riservate.699a44b4.svg";